import React from "react";

/**
 * Brand logo — registered Acumen Financial Services Ltd artwork.
 * Renders cleanly on any background (transparent PNG, no card).
 *
 * A small "Ltd" badge is anchored at the bottom-right of the wordmark
 * (per HL Partnership FP requirement to make the full registered company
 * name — Acumen Financial Services Ltd — visible on the logo). This is
 * an inline text badge rather than a re-drawn logo, so the existing
 * artwork remains untouched.
 */
export default function Logo({ className = "", variant = "dark" }) {
    return (
        <span
            data-testid="acumen-logo-wrap"
            className={`relative inline-flex items-end select-none ${className}`}
        >
            <img
                src="/logo-acumen.png?v=4"
                alt="Acumen Financial Services Ltd"
                data-testid="acumen-logo"
                className={`h-14 md:h-16 w-auto select-none ${
                    variant === "light"
                        ? "drop-shadow-[0_4px_14px_rgba(0,0,0,0.35)]"
                        : ""
                }`}
                draggable="false"
            />
            <span
                data-testid="acumen-logo-ltd"
                aria-hidden="true"
                className="-ml-2 md:-ml-2.5 mb-2 md:mb-2.5 text-[11px] md:text-xs font-black tracking-tight text-black leading-none"
            >
                Ltd
            </span>
        </span>
    );
}
